import { render, staticRenderFns } from "./listar-sedes.vue?vue&type=template&id=e572bdfa"
import script from "./listar-sedes.vue?vue&type=script&lang=js"
export * from "./listar-sedes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports